module.exports = __webpack_public_path__ + "img/22.afa62f51.png";